import { render, staticRenderFns } from "./ListarPedidos.vue?vue&type=template&id=1683ae40&"
import script from "./ListarPedidos.vue?vue&type=script&lang=js&"
export * from "./ListarPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports